<ng-container *transloco="let convert;">
  <div class="card">
    <div class="filters-title-container">
      <h2 class="filters-title">{{convert('sellModule.manageInventory.searchFilter.textFilters')}}</h2>
      @if (isInServiceVehiclesEnabled) {
        <app-vehicle-type-select
          (vehicleTypeSelection)="selectVehicleType($event)"
          [filterByIsv]="filterByIsv">
        </app-vehicle-type-select>
      }
      <div class="form-group">
        @if (isSoldInventoryFeatureEnabled) {
          <div class="custom-control custom-radio mb-3 mt-3">
            <input
              class="custom-control-input"
              id="status-filter-active"
              type="radio"
              [name]="isMobile ? 'status-filter-mobile' : 'status-filter'"
              data-track-elem="radio"
              data-track-trigger="filter"
              data-track-name="Active"
              [value]="statusFilterTypes.active"
              [checked]="filterByStatusSelected === statusFilterTypes.active"
              (click)="setStatusFilterUI($event)"
              aria-labelledby="status-filter-active__label"
              [attr.aria-checked]="filterByStatusSelected === statusFilterTypes.active"
              />
            <label id="status-filter-active__label" class="custom-control-label ms-2" for="status-filter-active"
              >{{convert('sellModule.manageInventory.searchFilter.textActiveVehicles')}}</label
              >
            </div>
          }
          @if (isReservedFilterEnabled && this.filterByIsv) {
            <div class="custom-control custom-radio mb-3">
              <input
                class="custom-control-input"
                id="status-filter-reserved"
                type="radio"
                [name]="isMobile ? 'status-filter-mobile' : 'status-filter'"
                data-track-elem="radio"
                data-track-trigger="filter"
                data-track-name="Reserved"
                [checked]="filterByStatusSelected === statusFilterTypes.reserved"
                [value]="statusFilterTypes.reserved"
                (click)="setStatusFilterUI($event)"
                aria-labelledby="status-filter-reserved__label"
                [attr.aria-checked]="filterByStatusSelected === statusFilterTypes.reserved"
                />
              <label class="custom-control-label ms-2" for="status-filter-reserved"
                >{{convert('sellModule.manageInventory.searchFilter.textReservedVehicles')}}</label
                >
              </div>
            }
            @if (isSoldInventoryFeatureEnabled) {
              <div class="custom-control custom-radio mb-3">
                <input
                  class="custom-control-input"
                  id="status-filter-sold"
                  type="radio"
                  [name]="isMobile ? 'status-filter-mobile' : 'status-filter'"
                  data-track-elem="radio"
                  data-track-trigger="filter"
                  data-track-name="Sold"
                  [checked]="filterByStatusSelected === statusFilterTypes.sold"
                  [value]="statusFilterTypes.sold"
                  (click)="setStatusFilterUI($event)"
                  aria-labelledby="status-filter-sold__label"
                  [attr.aria-checked]="filterByStatusSelected === statusFilterTypes.sold"
                  />
                <label id="status-filter-sold__label" class="custom-control-label ms-2" for="status-filter-sold"
                  >{{convert('sellModule.manageInventory.searchFilter.textSoldVehicles')}}</label
                  >
                </div>
              }
              @if (isSharedVehicleFilterEnabled) {
                <div class="custom-control custom-radio mb-3">
                  <input
                    class="custom-control-input"
                    id="status-filter-shared"
                    type="radio"
                    [name]="isMobile ? 'status-filter-mobile' : 'status-filter'"
                    data-track-elem="radio"
                    data-track-trigger="filter"
                    [attr.data-track-name]="analyticsRadioOption"
                    [checked]="filterByStatusSelected === statusFilterTypes.shared"
                    [value]="statusFilterTypes.shared"
                    (click)="setStatusFilterUI($event)"
                    aria-labelledby="status-filter-shared"
                    [attr.aria-checked]="filterByStatusSelected === statusFilterTypes.shared"
                    />
                  <label id="status-filter-shared__label" class="custom-control-label ms-2" for="status-filter-shared"
                    >{{ searchFilterTranslations.labelSharedVehiclesFilter }}</label
                    >
                  </div>
                }
                @if (isSellHoldFilterEnabled && !this.filterByIsv || isSellUpdateInventoryFeatureEnabled) {
                  <div class="custom-control custom-radio mb-3">
                    <input
                      class="custom-control-input"
                      id="status-filter-hold"
                      type="radio"
                      [name]="isMobile ? 'status-filter-mobile' : 'status-filter'"
                      data-track-elem="radio"
                      data-track-trigger="filter"
                      data-track-name="Hold"
                      [checked]="filterByStatusSelected === statusFilterTypes.hold"
                      [value]="statusFilterTypes.hold"
                      (click)="setStatusFilterUI($event)"
                      aria-labelledby="status-filter-hold__label"
                      [attr.aria-checked]="filterByStatusSelected === statusFilterTypes.hold"
                      />
                    <label id="status-filter-hold__label" class="custom-control-label ms-2" for="status-filter-hold"
                      >{{convert('sellModule.manageInventory.searchFilter.textHoldVehicles')}}</label
                      >
                    </div>
                  }
                  @if (isSellRemovedFilterEnabled || isSellUpdateInventoryFeatureEnabled) {
                    <div class="custom-control custom-radio mb-3">
                      <input
                        class="custom-control-input"
                        id="status-filter-removed"
                        type="radio"
                        [name]="isMobile ? 'status-filter-mobile' : 'status-filter'"
                        data-track-elem="radio"
                        data-track-trigger="filter"
                        data-track-name="Removed"
                        [checked]="filterByStatusSelected === statusFilterTypes.removed"
                        [value]="statusFilterTypes.removed"
                        (click)="setStatusFilterUI($event)"
                        aria-labelledby="status-filter-removed__label"
                        [attr.aria-checked]="filterByStatusSelected === statusFilterTypes.removed"
                        />
                      <label class="custom-control-label ms-2" for="status-filter-removed"
                        >{{convert('sellModule.manageInventory.searchFilter.textRemovedVehicles')}}</label
                        >
                      </div>
                    }
                    @if (isSellAllFilterEnabled || isSellUpdateInventoryFeatureEnabled) {
                      <div class="custom-control custom-radio mb-3">
                        <input
                          class="custom-control-input"
                          id="status-filter-all"
                          type="radio"
                          [name]="isMobile ? 'status-filter-mobile' : 'status-filter'"
                          data-track-elem="radio"
                          data-track-trigger="filter"
                          data-track-name="All"
                          [checked]="filterByStatusSelected === statusFilterTypes.all"
                          [value]="statusFilterTypes.all"
                          (click)="setStatusFilterUI($event)"
                          aria-labelledby="status-filter-all_label"
                          [attr.aria-checked]="filterByStatusSelected === statusFilterTypes.all"
                          />
                        <label id="status-filter-all__label" class="custom-control-label ms-2" for="status-filter-all"
                          >{{convert('sellModule.manageInventory.searchFilter.textAllVehicles')}}</label
                          >
                        </div>
                      }
                    </div>
                    @if (showTenantFilter) {
                      <app-radio-button-group
                        [label]="convert('sellModule.manageInventory.searchFilter.labelTenant')"
                        [radioButtonGroup]="tenants"
                        (subfilterSelection)="setTenantFilter($event)"
                        >
                      </app-radio-button-group>
                    }

                    @if (isActiveVehiclesFilterSelected && showBidLeftRailFilters) {
                      <app-radio-button-group
                        [label]="convert('sellModule.manageInventory.searchFilter.labelBids')"
                        [radioButtonGroup]="bids"
                        (subfilterSelection)="setBidFilter($event)"
                        >
                      </app-radio-button-group>
                    }
                    @if (isRemovalFilterHideShow && showRemovalTypeLeftRailFilters) {
                      <div>
                        <h2 class="filters-title">{{convert('sellModule.manageInventory.searchFilter.textRemovalType')}} </h2>
                        <div class="form-group">
                          <div class="custom-control custom-radio mb-3 mt-3">
                            <input
                              class="custom-control-input radio-remove-type"
                              id="remove-filter-active"
                              type="radio"
                              [name]="remove-filter"
                              data-track-elem="radio"
                              data-track-trigger="filter"
                              data-track-name="Removed"
                              [checked]="removalFilterByAll"
                              [value]="removeFilterByTypes.all"
                              (change)="setRepostedFilterUI($event)"
                              aria-labelledby="status-filter-removed__label"
                              [attr.aria-checked]="removalFilterByAll"
                              />
                            <label id="status-filter-removed__label" class="custom-control-label ms-2"
                            for="remove-filter-active">{{convert('sellModule.manageInventory.searchFilter.textAll')}}</label>
                          </div>
                          <div class="custom-control custom-radio mb-3 mt-3">
                            <input class="custom-control-input radio-remove-type"
                              id="remove-filter-not_reposted"
                              type="radio"
                              [name]="remove-filter"
                              data-track-elem="radio"
                              data-track-trigger="filter"
                              data-track-name="Not_Reposted"
                              [value]="removeFilterByTypes.not_reposted"
                              [checked]="removalFilterByNotReposted"
                              (change)="setRepostedFilterUI($event)"
                              aria-labelledby="status-filter-not_reposted__label"
                              [attr.aria-checked]="removalFilterByNotReposted"
                              />
                            <label id="status-filter-not_reposted__label" class="custom-control-label ms-2"
                            for="remove-filter-not_reposted">{{convert('sellModule.manageInventory.searchFilter.labelNotReposted')}}</label>
                          </div>
                          <div class="custom-control custom-radio mb-3 mt-3">
                            <input class="custom-control-input radio-remove-type"
                              id="remove-filter-reposted" type="radio"
                              [name]="remove-filter"
                              data-track-elem="radio"
                              data-track-trigger="filter"
                              data-track-name="Reposted"
                              [value]="removeFilterByTypes.reposted"
                              [checked]="removalFilterByReposted"
                              (change)="setRepostedFilterUI($event)"
                              aria-labelledby="status-filter-reposted__label"
                              [attr.aria-checked]="removalFilterByReposted"
                              />
                            <label id="status-filter-reposted__label" class="custom-control-label ms-2"
                            for="remove-filter-reposted">{{convert('sellModule.manageInventory.searchFilter.labelReposted')}}</label>
                          </div>
                        </div>
                      </div>
                    }

                    @if (filterByStatusSelected === 'SOLD' || filterByStatusSelected === 'REMOVED') {
                      <div>
                        @if (isSellReservationFiltersEnabled && filterByIsv) {
                          <div class="sell-filter-section-header sold-filter-title fw-bold">{{searchFilterTranslations.labelSoldDate}}</div>
                        }
                        <lib-utility-bar-date-range
                          [trackCalendars]="true"
                          class="ms-auto pt-2 mobile-datepicker vertical-date-range"
                          >
                        </lib-utility-bar-date-range>
                      </div>
                    }
                  </div>

                  @if (isSharedVehiclesFilterSelected && sharedListFilterState$ | async; as vm) {
                    <lib-search-filter-section
                title="{{this.filterByIsv === false ? convert('sellModule.manageInventory.searchFilter.titleSharedWith') :
                convert('sellModule.manageInventory.searchFilter.titleInvoicedTo')}}"
                      [open]="vm.openFilter === 'sharedLists'"
                      (openChange)="searchFiltersService.selectFilter('sharedLists')"
                      >
                      <div class="form-group">
                        <div class="custom-control custom-radio mb-3">
                          <input
                            class="custom-control-input"
                            id="shared-filter-none"
                            type="radio"
                            data-track-elem="radio"
                            data-track-trigger="filter"
                            data-track-name="All Recipients"
                            [value]="offerFilterTypes.none"
                            [checked]="allRecipientSelected"
                            (change)="handleOfferListRadioButton(vm.sharedList, null, null, null)"
                            aria-labelledby="shared-filter-all__label"
                            />
                          <label id="shared-filter-all__label" class="custom-control-label ms-2" for="shared-filter-none">
                          {{convert('sellModule.manageInventory.searchFilter.labelAllRecipients')}}</label>
                          @if (userFilterValue === 'NONE') {
                            <div>
                              @if (vm.openFilter === 'sharedLists') {
                                <div>
                                  @if (vm.sharedList) {
                                    <div>
                                      @for (list of vm.sharedList| slice: 0:(vm.showAll ? vm.sharedList.length : 9); track dealerListById(i, list); let i = $index) {
                                        <div class="shared-list-filter"
                                          >
                                          <lib-search-filter-section
                                            title="{{list.buyerDealerName}}"
                                            variant="link"
                                            [analyticsName]="'Buying Dealer Name (accordion)'"
                                            [open]="determineIfDealerShipIsOpen(list)"
                                            (openChange)="openDealerShipDropDown(list)"
                                            >
                                            @if (determineIfDealerShipIsOpen(list)) {
                                              @for (recipient of list.recipientOfferLists; track recipient; let j = $index) {
                                                <div>
                                                  <label class="recipient-label"> {{recipient.buyerRecipientName}}</label>
                                                  <ng-container>
                                                    <ul class="shared-list-button">
                                                      @for (offerList of recipient.offerLists; track offerList; let l = $index) {
                                                        <li class="custom-control custom-radio mb-3"
                                                          >
                                                          <input
                                                            class="custom-control-input"
                                                            [attr.id]="recipient.buyerRecipientName + '-' + offerList.offerListUuid"
                                                            type="radio"
                                                            data-track-elem="radio"
                                                            data-track-trigger="filter"
                                                            [attr.data-track-name]="'List Name'"
                                                            [value]="offerList.offerListUuid"
                                                            [attr.aria-labelledBy]="'shared-list-' + offerList.offerListName + '__label'"
                                                            [checked]="offerList.selected"
                                                            (change)="handleOfferListRadioButton(vm.sharedList, recipient, offerList, list.buyerDealerName)"
                                                            />
                                                          <label
                                                            [attr.id]="recipient.buyerRecipientName + '-' + offerList.offerListUuid + '__label'"
                                                            class="custom-control-label ms-2"
                                                            [for]="recipient.buyerRecipientName + '-' + offerList.offerListUuid">
                                                            {{ getListName(offerList)}}
                                                          </label>
                                                        </li>
                                                      }
                                                    </ul>
                                                  </ng-container>
                                                </div>
                                              }
                                            }
                                          </lib-search-filter-section>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                              @if (vm.sharedList.length > 9) {
                                <div>
                                  <button
                                    data-track-elem="button"
                                    [id]="dataTrackId(vm.showAll, vm.dealerCount)"
                                    class="btn-link text-primary fw-bold"
                                    type="button"
                                    (click)="searchFiltersService.toggleShowAllSharedList()"
                                    >
                                    {{ !vm.showAll ? convert('sellModule.manageInventory.searchFilter.labelShowAllDealers', {dealerCount: vm.dealerCount}) : convert('sellModule.manageInventory.searchFilter.labelShowLess') }}
                                  </button>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </lib-search-filter-section>
                  }

                  @if (showOffersLeftRailFilters) {
                    @if (filterByStatusSelected === 'ACTIVE' && offerFiltersState$ | async; as vm) {
                      <lib-search-filter-section
                        title="{{convert('sellModule.manageInventory.searchFilter.titleOffers')}}"
                        [open]="vm.openFilter === 'offers'"
                        (openChange)="searchFiltersService.selectFilter('offers')"
                        >
                        <div class="form-group">
                          <div class="custom-control custom-radio mb-3">
                            <input
                              class="custom-control-input"
                              id="offer-filter-none"
                              type="radio"
                              [name]="isMobile ? 'offer-filter-mobile' : 'offer-filter'"
                              data-track-elem="radio"
                              data-track-trigger="filter"
                              data-track-name="Don't filter by Offers"
                              [value]="offerFilterTypes.none"
                              [checked]="!vm.isActiveFilter || vm.dealerFilter === offerFilterTypes.none"
                              (click)="setOfferFilterUI($event)"
                              aria-labelledby="offer-filter-none__label"
                              />
                            <label id="offer-filter-none__label" class="custom-control-label ms-2" for="offer-filter-none"
                              >{{convert('sellModule.manageInventory.searchFilter.labelDontFilter')}}</label
                              >
                            </div>
                            <div class="custom-control custom-radio mb-3">
                              <input
                                class="custom-control-input"
                                id="offer-filter-only-offers"
                                [name]="isMobile ? 'offer-filter-mobile' : 'offer-filter'"
                                type="radio"
                                data-track-elem="radio"
                                data-track-trigger="filter"
                                data-track-name="Show all vehicles with Offers"
                                [value]="offerFilterTypes.withOffers"
                                [checked]="vm.dealerFilter === offerFilterTypes.withOffers"
                                (click)="setOfferFilterUI($event)"
                                aria-labelledby="offer-filter-only-offers__label"
                                />
                              <label id="offer-filter-only-offers__label" class="custom-control-label ms-2"
                                for="offer-filter-only-offers"
                                >{{convert('sellModule.manageInventory.searchFilter.labelOutstandingOffers')}}</label
                                >
                              </div>
                              @if (isShowBuyingDealershipName) {
                                <div class="custom-control custom-radio mb-3">
                                  <input
                                    class="custom-control-input"
                                    id="offer-filter-by-dealer"
                                    [name]="isMobile ? 'offer-filter-mobile' : 'offer-filter'"
                                    type="radio"
                                    data-track-elem="radio"
                                    data-track-trigger="filter"
                                    data-track-name="Show Offers made by selected dealers"
                                    [value]="offerFilterTypes.byDealer"
                                    [checked]="vm.dealerFilter === offerFilterTypes.byDealer"
                                    (click)="setOfferFilterUI($event)"
                                    aria-labelledby="offer-filter-by-dealer__label"
                                    />
                                  <label id="offer-filter-by-dealer__label" class="custom-control-label ms-2"
                                    for="offer-filter-by-dealer"
                                    >{{convert('sellModule.manageInventory.searchFilter.labelAllOffer')}}</label
                                    >
                                  </div>
                                }
                              </div>
                              @if (vm.openFilter === 'offers' && vm.dealerFilter === offerFilterTypes.byDealer) {
                                <div class="form-group"
                                  >
                                  @if (vm.dealerList) {
                                    <div class="control-wrapper">
                                      <ul>
                                        @if (vm.dealerList.length > 1) {
                                          <li class="custom-control custom-checkbox">
                                            <input
                                              class="custom-control-input"
                                              id="offer-option-1"
                                              type="checkbox"
                                              data-track-elem="checkbox"
                                              data-track-trigger="filter"
                                              data-track-name="Select All"
                                              (change)="toggleSelectAllOffers()"
                                              [checked]="vm.selectAllChecked"
                                              #selectAllOffers
                                              aria-labelledby="offer-option-1__label"
                                              />
                                            <label id="offer-option-1__label" class="custom-control-label ms-2"
                                            for="offer-option-1">{{convert('sellModule.manageInventory.searchFilter.labelSelectAll')}}</label>
                                          </li>
                                        }
                                        <!-- Show 9 or all dealers -->
                                        @for (dealer of vm.dealerList | slice: 0:(vm.showAll ? vm.dealerList.length : 9); track dealerById($index, dealer)) {
                                          <li
                                            class="custom-control custom-checkbox"
                                            >
                                            <input
                                              class="custom-control-input"
                                              [attr.id]="'dealer-offers-' + dealer.organizationEntityUuid"
                                              type="checkbox"
                                              [checked]="dealer.selected"
                                              data-track-elem="checkbox"
                                              data-track-trigger="filter"
                                              [attr.data-track-name]="dealer.name"
                                              [value]="dealer.organizationEntityUuid"
                                              (change)="selectDealerOffer(dealer.organizationEntityUuid)"
                                              [attr.aria-labelledBy]="'dealer-offers-' + dealer.organizationEntityUuid + '__label'"
                                              />
                                            <label
                                              [attr.id]="'dealer-offers-' + dealer.organizationEntityUuid + '__label'"
                                              class="custom-control-label ms-2"
                                              [attr.for]="'dealer-offers-' + dealer.organizationEntityUuid"
                                              >{{ dealer.name }}</label
                                              >
                                            </li>
                                          }
                                        </ul>
                                      </div>
                                    }
                                  </div>
                                }
                                @if (vm.dealerList.length > 9) {
                                  <div>
                                    <button
                                      data-track-elem="button"
                                      [attr.data-track-name]="!vm.showAll ? convert('sellModule.manageInventory.searchFilter.labelShowAllDealers',{dealerCount: vm.dealerCount}) : convert('sellModule.manageInventory.searchFilter.labelShowLess')"
                                      class="btn-link text-primary fw-bold"
                                      type="button"
                                      (click)="searchFiltersService.toggleShowAllOffers()"
                                      >
                                      {{ !vm.showAll ? convert('sellModule.manageInventory.searchFilter.labelShowAllDealers', {dealerCount: vm.dealerCount}) : convert('sellModule.manageInventory.searchFilter.labelShowLess') }}
                                    </button>
                                  </div>
                                }
                              </lib-search-filter-section>
                            }
                          }


                          @if (isSharedVehiclesFilterSelected && !this.filterByIsv && userFilterState$ | async; as userFilterState) {
                            <lib-search-filter-section
                              title="{{convert('sellModule.manageInventory.searchFilter.titleOffers')}}"
                              [open]="userFilterState.openFilter === 'offers'"
                              (openChange)="searchFiltersService.selectFilter('offers')"
                              >
                              <div class="form-group">
                                <div class="custom-control custom-radio mb-3">
                                  <input
                                    class="custom-control-input"
                                    id="offer-filter-none"
                                    type="radio"
                                    [name]="isMobile ? 'offer-filter-mobile' : 'offer-filter'"
                                    data-track-elem="radio"
                                    data-track-trigger="filter"
                                    data-track-name="Don't filter by Offers"
                                    [value]="statusFilterTypes.shared"
                                    [checked]="allRecipientSelected"
                                    (change)="setFilterByUserUI($event, 'NONE')"
                                    aria-labelledby="offer-filter-none__label"
                                    />
                                  <label id="offer-filter-none__label" class="custom-control-label ms-2" for="offer-filter-none"
                                    >{{convert('sellModule.manageInventory.searchFilter.labelDontFilter')}}</label
                                    >
                                  </div>
                                  <div class="custom-control custom-radio mb-3">
                                    <input
                                      class="custom-control-input"
                                      id="offer-filter-only-offers"
                                      [name]="isMobile ? 'offer-filter-mobile' : 'offer-filter'"
                                      type="radio"
                                      data-track-elem="radio"
                                      data-track-trigger="filter"
                                      data-track-name="Show all vehicles with Offers"
                                      [value]="offerFilterTypes.withOffers"
                                      [checked]="userFilterState.dealerFilter === offerFilterTypes.withOffers"
                                      (click)="setFilterByUserUI($event, 'OUTSTANDING')"
                                      aria-labelledby="offer-filter-only-offers__label"
                                      />
                                    <label id="offer-filter-only-offers__label" class="custom-control-label ms-2"
                                      for="offer-filter-only-offers"
                                      >{{convert('sellModule.manageInventory.searchFilter.labelOutstandingOffers')}}</label
                                      >
                                    </div>
                                    <div class="custom-control custom-radio mb-3">
                                      <input
                                        class="custom-control-input"
                                        id="offer-filter-by-dealer"
                                        [name]="isMobile ? 'offer-filter-mobile' : 'offer-filter'"
                                        type="radio"
                                        data-track-elem="radio"
                                        data-track-trigger="filter"
                                        data-track-name="Selling Dealer Name"
                                        [value]="offerFilterTypes.byDealer"
                                        [checked]="userFilterState.dealerFilter === offerFilterTypes.byDealer"
                                        (click)="setFilterByUserUI($event, 'ALL')"
                                        aria-labelledby="offer-filter-by-dealer__label"
                                        />
                                      <label id="offer-filter-by-dealer__label" class="custom-control-label ms-2"
                                        for="offer-filter-by-dealer"
                                        >{{ searchFilterTranslations.labelAllOffersTo + sellerDealerName }}</label
                                        >
                                      </div>
                                    </div>
                                    @if (userFilterState.openFilter === 'offers' && userFilterState.dealerFilter === offerFilterTypes.byDealer) {
                                      <div class="form-group"
                                        >
                                        @if (userFilterState.userList) {
                                          <div class="control-wrapper">
                                            <ul>
                                              @if (userFilterState.userList.length > 1) {
                                                <li class="custom-control custom-checkbox">
                                                  <input
                                                    class="custom-control-input"
                                                    id="offer-option-1"
                                                    type="checkbox"
                                                    data-track-elem="checkbox"
                                                    data-track-trigger="filter"
                                                    data-track-name="Select All"
                                                    (change)="toggleSelectAllUsers()"
                                                    [checked]="userFilterState.selectAllChecked"
                                                    #selectAllUsers
                                                    aria-labelledby="offer-option-1__label"
                                                    />
                                                  <label id="offer-option-1__label" class="custom-control-label ms-2"
                                                  for="offer-option-1">{{convert('sellModule.manageInventory.searchFilter.labelSelectAll')}}</label>
                                                </li>
                                              }
                                              <!-- Show 10 or all sellers -->
                                              @for (user of userFilterState.userList | slice: 0:(userFilterState.showAll ? userFilterState.userList.length : 10); track userById($index, user)) {
                                                <li
                                                  class="custom-control custom-checkbox"
                                                  >
                                                  <input
                                                    class="custom-control-input"
                                                    [attr.id]="'user-offers-' + user.offerListCreatorUuid"
                                                    type="checkbox"
                                                    [checked]="user.selected"
                                                    data-track-elem="checkbox"
                                                    data-track-trigger="filter"
                                                    [value]="user.offerListCreatorUuid"
                                                    (change)="selectUser(user.offerListCreatorUuid)"
                                                    />
                                                  <label
                                                    [attr.id]="'user-offers-' + user.offerListCreatorUuid + '__label'"
                                                    class="custom-control-label ms-2"
                                                    [attr.for]="'user-offers-' + user.offerListCreatorUuid"
                                                    >{{ user.sellerName }}</label
                                                    >
                                                  </li>
                                                }
                                              </ul>
                                            </div>
                                          }
                                        </div>
                                      }
                                      @if (userFilterState.userList.length > 10) {
                                        <div>
                                          <button
                                            data-track-elem="button"
                                            class="btn-link text-primary fw-bold"
                                            type="button"
                                            (click)="searchFiltersService.toggleShowAllUsers()"
                                            >
                                            {{ !userFilterState.showAll ? convert('sellModule.manageInventory.searchFilter.labelShowAllSellers', {dealerCount: userFilterState.dealerCount}) : convert('sellModule.manageInventory.searchFilter.labelShowLess') }}
                                          </button>
                                        </div>
                                      }
                                    </lib-search-filter-section>
                                  }


                                  @if (showQuestionsLeftRailFilters) {
                                    @if (filterByStatusSelected === 'ACTIVE' && questionFiltersState$ | async; as vm) {
                                      <lib-search-filter-section
                                        title="{{convert('sellModule.manageInventory.searchFilter.titleQuestions')}}"
                                        [open]="vm.openFilter === 'questions'"
                                        (openChange)="searchFiltersService.selectFilter('questions')"
                                        >
                                        <div class="custom-control custom-radio mb-3">
                                          <input
                                            class="custom-control-input"
                                            id="question-filter-none"
                                            [name]="isMobile ? 'question-filter-mobile' : 'question-filter'"
                                            type="radio"
                                            data-track-elem="radio"
                                            data-track-trigger="filter"
                                            data-track-name="Don't filter by Questions"
                                            [value]="questionFilterTypes.none"
                                            [checked]="!vm.isActiveFilter || vm.dealerFilter === questionFilterTypes.none"
                                            (click)="setQuestionFilterUI($event)"
                                            aria-labelledby="question-filter-none__label"
                                            />
                                          <label id="question-filter-none__label" class="custom-control-label ms-2" for="question-filter-none"
                                            >{{convert('sellModule.manageInventory.searchFilter.labelDontQuestion')}}</label
                                            >
                                          </div>
                                          <div class="custom-control custom-radio mb-3">
                                            <input
                                              class="custom-control-input"
                                              id="question-filter-only-questions"
                                              [name]="isMobile ? 'question-filter-mobile' : 'question-filter'"
                                              type="radio"
                                              data-track-elem="radio"
                                              data-track-trigger="filter"
                                              data-track-name="Show all vehicles with Questions"
                                              [value]="questionFilterTypes.withQuestions"
                                              [checked]="vm.dealerFilter === questionFilterTypes.withQuestions"
                                              (click)="setQuestionFilterUI($event)"
                                              aria-labelledby="question-filter-only-questions__label"
                                              />
                                            <label
                                              id="question-filter-only-questions__label"
                                              class="custom-control-label ms-2"
                                              for="question-filter-only-questions"
                                              >{{convert('sellModule.manageInventory.searchFilter.labelOutstandingQuestions')}}</label
                                              >
                                            </div>
                                            @if (isShowBuyingDealershipName) {
                                              <div class="custom-control custom-radio mb-3">
                                                <input
                                                  class="custom-control-input"
                                                  id="question-filter-by-dealer"
                                                  [name]="isMobile ? 'question-filter-mobile' : 'question-filter'"
                                                  allytmln="Selling Dealer Name"
                                                  type="radio"
                                                  data-track-elem="radio"
                                                  data-track-trigger="filter"
                                                  data-track-name="Selling Dealer Name"
                                                  [value]="questionFilterTypes.byDealer"
                                                  [checked]="vm.dealerFilter === questionFilterTypes.byDealer"
                                                  (click)="setQuestionFilterUI($event)"
                                                  aria-labelledby="question-filter-by-dealer__label"
                                                  />
                                                <label id="question-filter-by-dealer__label" class="custom-control-label ms-2"
                                                  for="question-filter-by-dealer"
                                                  >{{convert('sellModule.manageInventory.searchFilter.labelAllQuestion')}}</label
                                                  >
                                                </div>
                                              }
                                              @if (vm.openFilter === 'questions' && vm.dealerFilter === questionFilterTypes.byDealer) {
                                                <div class="form-group"
                                                  >
                                                  @if (vm.dealerList) {
                                                    <div class="control-wrapper">
                                                      <ul>
                                                        @if (vm.dealerList.length > 1) {
                                                          <li class="custom-control custom-checkbox">
                                                            <input
                                                              class="custom-control-input"
                                                              id="question-option-1"
                                                              type="checkbox"
                                                              data-track-elem="checkbox"
                                                              data-track-trigger="filter"
                                                              data-track-name="Select All"
                                                              (change)="toggleSelectAllQuestions()"
                                                              [checked]="vm.selectAllChecked"
                                                              #selectAllQuestions
                                                              aria-labelledby="question-option-1__label"
                                                              />
                                                            <label id="question-option-1__label" class="custom-control-label ms-2"
                                                              for="question-option-1"
                                                              >{{convert('sellModule.manageInventory.searchFilter.labelSelectAll')}}</label
                                                              >
                                                            </li>
                                                          }
                                                          <!-- Show 9 or all dealers -->
                                                          @for (dealer of vm.dealerList | slice: 0:(vm.showAll ? vm.dealerList.length : 9); track dealerById($index, dealer)) {
                                                            <li
                                                              class="custom-control custom-checkbox"
                                                              >
                                                              <input
                                                                class="custom-control-input"
                                                                [attr.id]="'dealer-offers-' + dealer.organizationEntityUuid"
                                                                type="checkbox"
                                                                [checked]="dealer.selected"
                                                                data-track-elem="checkbox"
                                                                data-track-trigger="filter"
                                                                [attr.data-track-name]="dealer.name"
                                                                [value]="dealer.organizationEntityUuid"
                                                                (change)="selectDealerQuestion(dealer.organizationEntityUuid)"
                                                                [attr.aria-labelledBy]="'dealer-offers-' + dealer.organizationEntityUuid + '__label'"
                                                                />
                                                              <label
                                                                [attr.id]="'dealer-offers-' + dealer.organizationEntityUuid + '__label'"
                                                                class="custom-control-label ms-2"
                                                                [attr.for]="'dealer-offers-' + dealer.organizationEntityUuid"
                                                                >{{ dealer.name }}</label
                                                                >
                                                              </li>
                                                            }
                                                          </ul>
                                                        </div>
                                                      }
                                                    </div>
                                                  }
                                                  @if (vm.dealerFilter === questionFilterTypes.byDealer && vm.dealerList.length > 9) {
                                                    <div>
                                                      <button
                                                        data-track-elem="button"
                                                        [attr.data-track-name]="!vm.showAll ? convert('sellModule.manageInventory.searchFilter.labelShowAllDealers',{dealerCount: vm.dealerCount}) : convert('sellModule.manageInventory.searchFilter.labelShowLess')"
                                                        class="btn-link text-primary fw-bold"
                                                        type="button"
                                                        (click)="searchFiltersService.toggleShowAllQuestions()"
                                                        >
                                                        {{ !vm.showAll ? convert('sellModule.manageInventory.searchFilter.labelShowAllDealers', {dealerCount: vm.dealerCount}) : convert('sellModule.manageInventory.searchFilter.labelShowLess') }}
                                                      </button>
                                                    </div>
                                                  }
                                                </lib-search-filter-section>
                                              }
                                            }

                                            @if (showSoldBidsOffersLeftRailFilters) {
                                              @if (filterByStatusSelected === 'SOLD' && wonDealersState$ | async; as vm) {
                                                <lib-search-filter-section
                                                  title="{{convert('sellModule.manageInventory.searchFilter.titleBidsOffers')}}"
                                                  [open]="filterByStatusSelected === 'SOLD' && vm.openFilter === 'bidsOffers'"
                                                  (openChange)="searchFiltersService.selectFilter('bidsOffers')"
                                                  >
                                                  <div class="custom-control custom-radio mb-3">
                                                    <input
                                                      class="custom-control-input"
                                                      id="bid-offer-filter-none"
                                                      [name]="isMobile ? 'bid-offer-filter-mobile' : 'bid-offer-filter'"
                                                      type="radio"
                                                      data-track-elem="radio"
                                                      data-track-trigger="filter"
                                                      data-track-name="Show all"
                                                      [checked]="selectedBidsOffers === undefined"
                                                      (change)="setBidsOffersFilter(undefined)"
                                                      aria-labelledby="bid-offer-filter-none__label"
                                                      />
                                                    <label id="bid-offer-filter-none__label" class="custom-control-label ms-2" for="bid-offer-filter-none"
                                                      >{{convert('sellModule.manageInventory.searchFilter.labelShowAll')}}</label
                                                      >
                                                    </div>
                                                    <div class="custom-control custom-radio mb-3">
                                                      <input
                                                        class="custom-control-input"
                                                        id="winning-bid-offer-dealers"
                                                        [name]="isMobile ? 'bid-offer-filter-mobile' : 'bid-offer-filter'"
                                                        type="radio"
                                                        data-track-elem="radio"
                                                        data-track-trigger="filter"
                                                        data-track-name="Winning bids/offers"
                                                        [value]="dealerFilters.wonByDealer"
                                                        [checked]="selectedBidsOffers === dealerFilters.wonByDealer"
                                                        (change)="setWonDealersFilter(dealerFilters.wonByDealer)"
                                                        aria-labelledby="winning-bid-offer-dealers__label"
                                                        />
                                                      <label id="winning-bid-offer-dealers__label" class="custom-control-label ms-2"
                                                        for="winning-bid-offer-dealers"
                                                        >{{convert('sellModule.manageInventory.searchFilter.labelWinningBidsOffers')}}</label
                                                        >
                                                      </div>
                                                      @if (selectedBidsOffers === dealerFilters.wonByDealer) {
                                                        <lib-dealer-filter
                                                          [dealersState]="wonDealersState$"
                                                          (toggleAll)="toggleAllWonDealers($event)"
                                                          (selectDealer)="selectWonDealer($event)"
                                                        ></lib-dealer-filter>
                                                      }
                                                      <div class="custom-control custom-radio mb-3">
                                                        <input
                                                          class="custom-control-input"
                                                          id="bids-offers-by-dealer"
                                                          [name]="isMobile ? 'bid-offer-filter-mobile' : 'bid-offer-filter'"
                                                          type="radio"
                                                          data-track-elem="radio"
                                                          data-track-trigger="filter"
                                                          data-track-name="Losing bids/offers"
                                                          [value]="dealerFilters.bidsOffersByDealer"
                                                          [checked]="selectedBidsOffers === dealerFilters.bidsOffersByDealer"
                                                          (change)="setLostDealersFilter(dealerFilters.bidsOffersByDealer)"
                                                          aria-labelledby="bids-offers-by-dealer__label"
                                                          />
                                                        <label id="bids-offers-by-dealer__label" class="custom-control-label ms-2" for="bids-offers-by-dealer"
                                                          >{{convert('sellModule.manageInventory.searchFilter.labelLosingBidsOffers')}}</label
                                                          >
                                                        </div>
                                                        @if (selectedBidsOffers === dealerFilters.bidsOffersByDealer) {
                                                          <lib-dealer-filter
                                                            [dealersState]="lostDealersState$"
                                                            (toggleAll)="toggleAllLostDealers($event)"
                                                            (selectDealer)="selectLostDealer($event)"
                                                          ></lib-dealer-filter>
                                                        }
                                                      </lib-search-filter-section>
                                                    }
                                                  }
                                                  @if (isGroundingStatusFilterHideShow) {
                                                    <lib-search-filter-section
                                                      title="{{convert('sellModule.manageInventory.searchFilter.titleGroundingStatus')}}"
                                                      [open]="groundedSectionOpen"
                                                      (openChange)="groundedSectionOpen = !groundedSectionOpen"
                                                      >
                                                      <div class="form-group">
                                                        <div class="custom-control custom-radio mb-3">
                                                          <input
                                                            class="custom-control-input"
                                                            id="grounded-filter-all"
                                                            type="radio"
                                                            [name]="isMobile ? 'grounded-filter-mobile' : 'grounded-filter'"
                                                            data-track-elem="radio"
                                                            data-track-trigger="filter"
                                                            data-track-name="All"
                                                            [value]="groundedFilterByTypes.all"
                                                            [checked]="groundedFilterByAll"
                                                            (change)="setGroundedStatusFilterUI($event)"
                                                            aria-labelledby="grounded-filter-all__label"
                                                            [attr.aria-checked]="groundedFilterByAll"
                                                            />
                                                          <label id="grounded-filter-all__label" class="custom-control-label ms-2" for="grounded-filter-all"
                                                            >{{convert('sellModule.manageInventory.searchFilter.textAll')}}</label
                                                            >
                                                          </div>
                                                          <div class="custom-control custom-radio mb-3">
                                                            <input
                                                              class="custom-control-input"
                                                              id="grounded-filter"
                                                              [name]="isMobile ? 'grounded-filter-mobile' : 'grounded-filter'"
                                                              type="radio"
                                                              data-track-elem="radio"
                                                              data-track-trigger="filter"
                                                              data-track-name="Grounded"
                                                              [value]="groundedFilterByTypes.grounded"
                                                              [checked]="groundedFilterByGrounded"
                                                              (change)="setGroundedStatusFilterUI($event)"
                                                              aria-labelledby="grounded-filter__label"
                                                              [attr.aria-checked]="groundedFilterByGrounded"
                                                              />
                                                            <label id="grounded-filter__label" class="custom-control-label ms-2"
                                                              for="grounded-filter"
                                                              >{{convert('sellModule.manageInventory.searchFilter.titleGrounded')}}</label
                                                              >
                                                            </div>
                                                            <div class="custom-control custom-radio mb-3">
                                                              <input
                                                                class="custom-control-input"
                                                                id="not-grounded-filter"
                                                                [name]="isMobile ? 'grounded-filter-mobile' : 'grounded-filter'"
                                                                type="radio"
                                                                data-track-elem="radio"
                                                                data-track-trigger="filter"
                                                                data-track-name="Not Grounded"
                                                                [value]="groundedFilterByTypes.not_grounded"
                                                                [checked]="groundedFilterByNotGrounded"
                                                                (change)="setGroundedStatusFilterUI($event)"
                                                                aria-labelledby="not-grounded-filter__label"
                                                                [attr.aria-checked]="groundedFilterByNotGrounded"
                                                                />
                                                              <label id="not-grounded-filter__label" class="custom-control-label ms-2"
                                                                for="not-grounded-filter"
                                                              >{{convert('sellModule.manageInventory.searchFilter.titleNotGrounded')}}</label>
                                                            </div>
                                                          </div>
                                                        </lib-search-filter-section>
                                                      }
                                                      @if (isReserveFilterEnabled) {
                                                        <div class="sell-filter-section-header fw-bold">{{searchFilterTranslations.labelReserveInformation}}</div>
                                                        <div class="reserve-information-filter">
                                                          <div class="custom-control mb-3">
                                                            <div class="form-group mb-0">
                                                              <label class="control-label text-uppercase fw-bold" for="avis-rep-select-dropdown" data-test-id="lib-search-filter-e-avis-rep-label">
                                                                {{searchFilterTranslations.labelAvisRep}}
                                                              </label>
                                                            </div>
                                                            <trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
                                                              <app-dropdown-select
                                                                id="avis-rep-select-dropdown"
                                                                label="Avis Rep"
                                                                [items]="reservedByUsersDropdown"
                                                                (click)="selectReservedByUsersDropdown($event)"
                                                                data-test-id="lib-search-filter-e-avis-rep-select-dropdown">
                                                              </app-dropdown-select>
                                                            </trap-focus>
                                                          </div>
                                                          <div class="custom-control mb-3">
                                                            <div class="form-group mb-0">
                                                              <label class="control-label text-uppercase fw-bold" for="dealership-select-dropdown" data-test-id="lib-search-filter-e-dealership-label">
                                                                {{searchFilterTranslations.labelDealership}}
                                                              </label>
                                                            </div>
                                                            <trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
                                                              <app-dropdown-select
                                                                id="dealership-select-dropdown"
                                                                label="Dealership"
                                                                [items]="dealershipDropdown"
                                                                (click)="selectDealershipDropdown($event)"
                                                                data-test-id="lib-search-filter-e-dealership-select-dropdown">
                                                              </app-dropdown-select>
                                                            </trap-focus>
                                                          </div>
                                                        </div>
                                                      }
                                                    </div>
                                                  </ng-container>
